module.exports = __webpack_public_path__ + "static/media/icon-export.4b62edaf.svg";